import { LANDING_AMPLITUDE_EVENTS, LOCAL_STORAGE_KEYS } from '@/constants';
import howWork from '@/public/images/jpg-to-webp-converter/howItWorks.webp';
import whyLift from '@/public/images/jpg-to-webp-converter/whyLift.webp';
import { type LandingConfigItem } from '../../types';
import { formatConverterConfig } from './formatConverterConfig';
import { tryLiftConfig } from './tryLiftConfig';

export const landingJpgToWebpConfig: LandingConfigItem = {
	id: 'JpgToWebpConverter',
	translationLocale: 'jpg-to-webp-converter',
	withDropZone: true,
	converterCompressor: true,
	hero: {
		type: 'default',
		title: 'heroData_title',
		description: 'heroData_subtitle',
		buttonText: 'heroData_buttonText',
		data: {
			dropzoneTitle: 'heroData_dropzoneTitle',
			format: 'sharedLandingData:format',
			size: 'sharedLandingData:size',
		},
		images: [
			{
				id: 'left',
				image: '',
				title: 'heroData_imageTitle1',
				alt: 'heroData_imageAlt1',
			},
			{
				id: 'right',
				image: '',
				title: 'heroData_imageTitle2',
				alt: 'heroData_imageAlt2',
			},
		],
	},
	howItWork: {
		title: 'howItWorkData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '🖼',
				title: 'howItWorkData_title1',
				subtitle: 'howItWorkData_subtitle1',
			},
			{
				icon: '🎯',
				title: 'howItWorkData_title2',
				subtitle: 'howItWorkData_subtitle2',
			},
			{
				icon: '⬇️',
				title: 'howItWorkData_title3',
				subtitle: 'howItWorkData_subtitle3',
			},
		],
		images: [
			{
				image: howWork,
				title: 'howItWorkData_imageTitle',
				alt: 'howItWorkData_imageAlt',
			},
		],
	},

	whyLift: {
		title: 'whyUseData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '✅',
				title: 'whyUseData_title1',
				subtitle: 'whyUseData_subtitle1',
			},
			{
				icon: '✅',
				title: 'whyUseData_title2',
				subtitle: 'whyUseData_subtitle2',
			},
			{
				icon: '✅',
				title: 'whyUseData_title3',
				subtitle: 'whyUseData_subtitle3',
			},
			{
				icon: '✅',
				title: 'whyUseData_title4',
				subtitle: 'whyUseData_subtitle4',
			},
			{
				icon: '✅',
				title: 'whyUseData_title5',
				subtitle: 'whyUseData_subtitle5',
			},
		],
		images: [
			{
				image: whyLift,
				title: 'whyUseData_imageTitle',
				alt: 'whyUseData_imageAlt',
			},
		],
	},
	faq: {
		title: 'faqData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				title: 'faqData_title1',
				subtitle: 'faqData_subtitle1',
			},
			{
				title: 'faqData_title2',
				subtitle: 'faqData_subtitle2',
			},
			{
				title: 'faqData_title3',
				subtitle: 'faqData_subtitle3',
			},
			{
				title: 'faqData_title4',
				subtitle: 'faqData_subtitle4',
			},
		],
	},

	formats: {
		...formatConverterConfig,
	},

	tryLift: {
		...tryLiftConfig,
	},
	analytics: {
		scrolledPercentName: LOCAL_STORAGE_KEYS.JPG_TO_WEBP_SCROLLED_POINTS,
		eventPropertyType: LANDING_AMPLITUDE_EVENTS.JPG_TO_WEBP,
		galleryContext: LANDING_AMPLITUDE_EVENTS.JPG_TO_WEBP_LANDING,
	},
};
